module.exports = __webpack_public_path__ + "static/assets/13845e22946385773258430cbb9f7b1a.png";